import { InclusionFilterStatus } from "@/enum/list.enum";
import { DropdownWithCheckboxesItem } from "@/components/DropdownWithCheckboxes/DropdownWithCheckboxes";

import { List } from "../../../schema/list";

/**
 * Options for the inclusion-status "Show" dropdown in the list table. Each entry pairs an
 * {@link InclusionFilterStatus} with its lean-list count and an explanatory tooltip. Extracted
 * from `UnassignedTable` so the empty-state breakdown can reuse the same count mapping.
 *
 * **There is deliberately no entry for a lead the list refused** (`InclusionStatus.SKIPPED`,
 * PREC-4094). A lead that is already on another list was never added to this one, and the product
 * decision is that it is not visible in the list view at all — not as a bucket, not as a count, not
 * as something to filter by. The row exists only in the database, with its `exclusion_reason`, so
 * support can answer "why is this list smaller than the source". Do not add a fifth option here.
 */
export const getInclusionFilterOptions = (
	ts: (key: string) => string,
	list?: List
): DropdownWithCheckboxesItem[] => [
	{
		title: ts(`filterOptions.${InclusionFilterStatus.ADDED}`),
		id: InclusionFilterStatus.ADDED,
		count: list?.draftCount,
		information:
			"All leads that have been added to the list and fit the ICP qualification criteria",
	},
	{
		title: ts(`filterOptions.${InclusionFilterStatus.UNSURE}`),
		id: InclusionFilterStatus.UNSURE,
		count: list?.excludedCount,
		information:
			"All leads that have been excluded from the list, because they don't fit the ICP qualification criteria or lack the required information",
	},
	{
		title: ts(`filterOptions.${InclusionFilterStatus.NOT_FOUND}`),
		id: InclusionFilterStatus.NOT_FOUND,
		count: list?.maybeCount,
		information: "All leads or companies that we were not able to identify.",
	},
	{
		title: ts(`filterOptions.${InclusionFilterStatus.BLACKLIST}`),
		id: InclusionFilterStatus.BLACKLIST,
		count: list?.blacklistCount,
		information: "All leads that have been added to the blacklist.",
	},
];
